import { createContext, useContext } from "react";

export const MessageModalContext = createContext(null);

export const useMessageModal = () => useContext(MessageModalContext);


// import to use:
// import { useMessageModal } from "@/components/messageModal/MessageModalContext";
// const messageModalRef = useMessageModal();
